<template>
  <div class="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    const savedPageFontSize = localStorage.getItem('pageFontSize')
    const pageFontSize = savedPageFontSize ? parseInt(savedPageFontSize) : 16
    document.documentElement.style.setProperty('--global-page-font-size', pageFontSize + 'px')
  }
}
</script>

<style>
html,
body,
#app,
.app {
  font-size: var(--global-page-font-size, 14px);
}

.el-button,
.el-input,
.el-input__inner,
.el-form-item__label,
.el-table,
.el-table th,
.el-table td,
.el-dialog__title,
.el-tabs__item,
.el-tree-node__label {
  font-size: inherit;
}
</style>
